import type {
  HubAlgorithmDefinition,
  HubParameterArtifact,
  HubParameterDefinitionField,
  HubParameterGroupDefinition,
} from '@robovision/hub'
import {
  JobBaseArtifact,
  type JobBaseArtifactParams,
} from './JobBaseArtifact'


export interface JobParameterArtifactParams extends JobBaseArtifactParams {
  fields: HubParameterDefinitionField[]
  groups: HubParameterGroupDefinition[]
  name: string
}

export class JobParameterArtifact extends JobBaseArtifact {
  public fields: HubParameterDefinitionField[]
  public groups: HubParameterGroupDefinition[]
  public override name: string = 'JobParameterArtifact default name'

  protected constructor (params: JobParameterArtifactParams) {
    super(params)
    this.fields = params.fields
    this.groups = params.groups
    this.name = params.name
  }

  public static fromDefinition (
    parameterArtifact: HubParameterArtifact,
    algorithmDefinition: HubAlgorithmDefinition,
  ) {
    const def = algorithmDefinition.parameterDefinitions?.find(
      (def) => def.id === parameterArtifact.parameterDefinition,
    )

    if (!def) {
      throw new Error(
        `Invalid schema. Parameter definition ${parameterArtifact.parameterDefinition} not found`,
      )
    }

    return new JobParameterArtifact({
      artifactId: parameterArtifact.id,
      definitionId: def.id,
      description: parameterArtifact.description,
      fields: def.schema?.fields ?? [],
      groups: def.schema?.groups ?? [],
      name: parameterArtifact.name ?? def.name,
    })
  }
}
